/**
 * @Author: 左建
 * @Date: 2022/6/30 14:04
 * @LastEditTime: 2022/6/30 14:04
 * @Description:  问卷的一些静态属性，以及一些转换方法
 */
import { getQuestionnaireDetail } from "@/api/new-question-iteration/question-library"
import { uuid } from "@/utils/index";
// 题型数据
const QUESTION_DATA = Object.freeze([
    { val: "single", text: "单选题", key: "single", num: 1 },
    { val: "multiple", text: "多选题", key: "multiple", num: 2 },
    { val: "filling", text: "填空题", key: "filling", num: 3 },
])

// 题型名称映射
export const QUESTION_TITLE = QUESTION_DATA.reduce((preVal, curVal) => {
    preVal[curVal.key] = curVal.text
    return preVal
}, Object.create(null))

// 题型val映射
export const QUESTION_VAL = QUESTION_DATA.reduce((preVal, curVal) => {
    preVal[curVal.key] = curVal.val
    return preVal
}, Object.create(null))

// 欢迎语
export const WELCOME = "为了给您提供更好的服务，希望您能抽出几分钟时间，将您的感受和建议告诉我们，我们非常重视每位用户的宝贵意见，期待您的参与！现在我们就马上开始吧！"

// 问卷标题
export const TITLE = "问卷标题"

// 问卷默认题干
export const STEM = "这是试题题干内容这是试题题干内容这是试题题干内容这是试题题干内容？(   )"

// 问卷Num映射
export const QUESTION_NUM = QUESTION_DATA.reduce((preVal, curVal) => {
    preVal[curVal.val] = curVal.num
    return preVal
}, Object.create(null))

// 问卷number-val映射
export const QUESTION_NUM_VAL = QUESTION_DATA.reduce((preVal, curVal) => {
    preVal[curVal.num] = curVal.val
    return preVal
}, Object.create(null))

// 问卷试题状态映射(管理端)
export const QUESTION_STATUS = Object.freeze({
    0: "未发布",
    1: "发布中",
    2: "收集中",
    3: "已结束"
})
// 问卷试题状态映射(用户端)
export const QUESTION_STATUS_USER = Object.freeze({
    0: "未开始",
    1: "进行中",
    2: "已作答",
    3: "已结束"
})

export default QUESTION_DATA

// 检验是否是url地址
export function isUrl (str) {
    const patternUrl = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/
    return patternUrl.test(str)
}
/**
 * 将问卷详情的数据统一格式化为规范的数据
 * @param qid {String} 问卷id
 * @param callback {Function} callback 回调函数
 * @return {undefined}
 */
export function formatQuestionnaire (qid, callback) {
    getQuestionnaireDetail(qid).then(res => {
        formatBackQuestionnaire(res, callback)
    })
}

/**
 * 生成后端需要的问卷数据格式
 * @param formatData 前端的Questionnaire数据
 * @return {Object}
 */

export function generateBackstageQuestionnaire (formatData) {
    const { title, welcome, questionList } = formatData
    const tags = questionList.map((item, index) => {
        item.order = index
        return item
    }).filter(item => item.type === "textDesc")
    return {
        Name: title,
        Title: welcome,
        Details: questionList.filter(item => item.type !== "textDesc").map(item => ({
            Type: QUESTION_NUM[item.type],
            Title: item.stem, // 题干
            Remark: item.remark, // 备注
            IsMustAnswer: item.required ? 1 : 0, // 是否必答,
            Options: Array.isArray(item.options) ? item.options.map(item => item.text).join("|") : item.options,
            Id: item.Id,
            QuestionnaireId: item.QuestionnaireId
        })),
        Tag: tags.length ? JSON.stringify(tags) : ""
    }
}
/**
 * 将问卷详情的数据统一格式化为规范的数据
 * @param res {Object} 后端返回的数据
 * @param callback {Function} callback 回调函数
 * @return {undefined}
 */
export function formatBackQuestionnaire (res, callback) {
    const { Tag, Title, Id, QuestionnaireDetaillist, Name, GuestUserId } = res
    let questionList = QuestionnaireDetaillist.map((item, index) => {
        const { Title, Options, Type, Remark, IsMustAnswer, anser: answer, ...otherProps } = item
        return {
            stem: Title,
            options: (typeof Options === "string" && Options.split("|")).map((item, index) => {
                return { type: isUrl(item) ? "image" : "text", text: item }
            }) || Options,
            type: QUESTION_NUM_VAL[Type],
            remark: Remark,
            required: !!IsMustAnswer,
            no: uuid(5),
            No: index + 1,
            answer: [QUESTION_VAL.multiple].includes(QUESTION_NUM_VAL[Type]) ? (typeof answer === "string" ? answer.split("|") : []) : answer,
            ...otherProps
        }
    })
    if (Tag) {
        const tag = JSON.parse(Tag)
        tag.forEach(item => {
            item.options = ""
            item.type = "textDesc"
            item.text = "文本描述"
            questionList.splice(item.order, 0, item)
            delete item.order
            item.no = uuid(5)
        })
    }
    // eslint-disable-next-line standard/no-callback-literal
    callback({ welcome: Title, Id, title: Name, questionList, GuestUserId }, res)
}
